import request from '@/utils/request'

export default {

  /**
   * 修改收款通知
   * @param id
   * @param isNotifyOrderPaid
   * @returns {Entry|AxiosPromise<any>|IDBRequest|Promise<void>}
   */
  updateNotifyPaid(id, isNotifyOrderPaid) {
    return request.put(`/account-merchants/${id}/update-notify-order-paid`, {
      is_notify_order_paid: isNotifyOrderPaid
    })
  },

  /**
   * 当前账号拥有的酒吧列表
   */
  availableMerchants() {
    return request.get(`/account-merchants/available/merchants`)
  }
}
